var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNiLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 39,
    viewBox: "0 0 44 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.9653 8.87825C39.6344 8.87825 38.5556 7.79939 38.5556 6.46854C38.5556 5.13769 39.6344 4.05882 40.9653 4.05882C42.2961 4.05882 43.375 5.13769 43.375 6.46854C43.375 7.79939 42.2961 8.87825 40.9653 8.87825ZM1.54604 27.2989C0.550906 24.9731 0 22.4119 0 19.722C0 9.07526 8.63092 0.444336 19.2777 0.444336C26.3883 0.444336 32.5998 4.29412 35.9415 10.0231C35.8363 10.0902 35.7379 10.1717 35.649 10.2674L21.6114 25.3848L17.6404 15.2367C16.9689 13.5205 14.7344 13.0961 13.4804 14.4466L1.54604 27.2989ZM3.03307 30.1063C6.4592 35.4549 12.4545 38.9998 19.2777 38.9998C29.9245 38.9998 38.5554 30.3688 38.5554 19.722C38.5554 17.3157 38.1145 15.0124 37.3091 12.8884L23.268 28.0097C22.0139 29.3602 19.7795 28.9358 19.1079 27.2196L15.1369 17.0715L3.03307 30.1063Z",
    fill: "#06345A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNiLogo);
export default __webpack_public_path__ + "static/media/ni-logo.b7e16fdf62968984bd3d77500cc7c2d1.svg";
export { ForwardRef as ReactComponent };